import cat4mroCataloger from './cat4mro';
import materials from './materials';
import amsaMaterials from './amsaMaterials';

export default {
  cat4mroCataloger,
  materials,
  amsaMaterials,
};



// WEBPACK FOOTER //
// ./src/store/modules/cataloger/index.js